import React, { ComponentProps, PropsWithChildren } from 'react';

import { Button, Spinner } from '@zapier/design-system';

type Props = ComponentProps<typeof Button> & {
  /** Flag to render the Spinner icon */
  isWorking: boolean;
};

const AsyncButton = ({
  children,
  isWorking,
  ...buttonProps
}: PropsWithChildren<Props>) => {
  const content = isWorking ? (
    <Spinner aria-label="Content is loading" />
  ) : (
    children
  );

  return <Button {...buttonProps}>{content}</Button>;
};

export default AsyncButton;
